import { render } from "./mispadres.vue?vue&type=template&id=4be71b35&scoped=true"
import script from "./mispadres.vue?vue&type=script&lang=js"
export * from "./mispadres.vue?vue&type=script&lang=js"

import "./mispadres.vue?vue&type=style&index=0&id=4be71b35&scoped=true&lang=css"
import "./mispadres.vue?vue&type=style&index=1&id=4be71b35&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4be71b35"]])

export default __exports__